export function isCompressedExternalOutputPath(
    filePath?: string | null,
): boolean {
    if (!filePath) return false;
    const normalized = filePath.replace(/\\/g, "/");
    return /(?:^|\/)[^/]+\.magic-md\/outputs\/[^/]+\.json\.br$/i.test(
        normalized,
    );
}

export function isCompressedExternalConfigPath(
    filePath?: string | null,
): boolean {
    if (!filePath) return false;
    const normalized = filePath.replace(/\\/g, "/");
    return /(?:^|\/)[^/]+\.magic-md\/configs\/[^/]+\.json\.br$/i.test(
        normalized,
    );
}

export function isCompressedExternalJsonPath(
    filePath?: string | null,
): boolean {
    return (
        isCompressedExternalOutputPath(filePath) ||
        isCompressedExternalConfigPath(filePath)
    );
}
